import Swal from "sweetalert2";
import { formatError, formatSuccess } from "../../services/AuthService";
import { downloadAdminPrefs, downloadOrder, downloadPostingOrder, downloadPrefs, fetchCategory, fetchDistricts, fetchLoggedInUser, fetchPosts, fetchPrefs, fetchRegStatus, saveDistPref, saveJoiningStatus, savePostPref, saveRegDetails, sentOtp } from "../../services/PreferenceService"
import { useDispatch } from "react-redux";
import { SEND_OTP_ACTION_ADMIN, SEND_OTP_FAILED_ACTION_ADMIN } from "./AdminActions";
import { loadingToggleAction } from "./AuthActions";

export const FETCH_CATEGORY_SUCCESS_ACTION = '[category action] confirmed category';
export const FETCH_CATEGORY_FAILED_ACTION = '[category action] failed category';
export const SAVE_REG_SUCCESS_ACTION = '[reg action] confirmed reg';
export const SAVE_REG_FAILED_ACTION = '[reg action] failed reg';
export const SAVE_PREF_STATUS_ACTION = '[pref action] failed pref';
export const FETCH_REG_STATUS_ACTION = '[reg-status action] failed reg-status';
export const FETCH_DISTRICT_SUCCESS_ACTION = '[district action] confirmed district';
export const FETCH_POST_SUCCESS_ACTION = '[post action] confirmed post';
export const FETCH_PREFS_SUCCESS_ACTION = '[pref action] confirmed prefs';
export const DOWN_PREFS_SUCCESS_ACTION = '[pref action download] confirmed prefs';
export const DOWN_PREFS_ADMIN_SUCCESS_ACTION = '[pref action admin download] confirmed prefs admin';
export const DOWN_ORDER_SUCCESS_ACTION = '[order action download] confirmed allocation';
export const SEND_OTP_ACTION = '[otp action] confirmed otp';
export const SEND_OTP_FAILED_ACTION = '[otp action] failed otp';
export function fetchCategoryAction() {
    return (dispatch) => {
        fetchCategory().then((response) => {
            dispatch(fetchCategorySuccess(response.data))
        }).catch((error) => {
            dispatch(fetchCategoryFailed(error.response))
        })
    }
}
export function fetchDistrictsAction(navigate) {
    return (dispatch) => {
        fetchRegStatus().then((response) => {
            let status = response.data;
            if (status === null) {
                navigate("/application-form");
            }
            else if (status === "REGISTERED") {
                let data = { status: status, data: [] }
                fetchRegStatusSuccess(status)
                fetchDistricts().then((response) => {
                    data.data = response.data.map(d => ({ district: d, preference: false }))
                    dispatch(fetchDistrictSuccess(data))
                }).catch((error) => {
                    formatError(error.response.data.message);
                })
            } else {
                dispatch(fetchRegStatusSuccess(status))
            }
        }).catch((error) => {
            formatError(error.response.data.message);
        })

    }
}
export function fetchPostsAction(navigate) {
    return (dispatch) => {
        fetchRegStatus().then((response) => {
            let status = response.data;
            if (status === null) {
                navigate("/application-form");
            }
            else if (status === "REGISTERED") {
                let data = { status: status, data: [] }
                fetchRegStatusSuccess(status)
                fetchPosts().then((response) => {
                    data.data = response.data
                    dispatch(fetchPostsSuccess(response.data))
                }).catch((error) => {
                    formatError(error.response.data.message);
                })
            } else {
                dispatch(fetchRegStatusSuccess(status))
            }
        }).catch((error) => {
            formatError(error.response.data.message);
        })
        fetchPosts().then((response) => {
            dispatch(fetchPostsSuccess(response.data))
        }).catch((error) => {
            formatError(error.response.data.message);
        })
    }
}
export function fetchPrefsAction() {
    return (dispatch) => {
        fetchPrefs().then((response) => {
            dispatch(fetchPrefsSuccess(response.data))
        }).catch((error) => {
            formatError(error.response.data.message);
        })
    }
}
export function downloadPrefsAction() {
    return (dispatch) => {
        downloadPrefs().then((response) => {
            dispatch(downloadPrefsSuccess(response.data))
        }).catch((error) => {
            formatError(error.response.data.message);
        })
    }
}
export function downloadPrefsAdminAction(reqNo) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        downloadAdminPrefs(reqNo).then((response) => {
            dispatch(downloadAdminPrefsSuccess(response.data))
        }).catch((error) => {
            formatError(error.response.data.message);
        }).finally(() => {
            dispatch(loadingToggleAction(false));
        });
    }
}
export function saveRegDetailsAction(formData, navigate) {
    return (dispatch) => {
        saveRegDetails(formData).then((response) => {
            formatSuccess(response.data.message);
            navigate("/district-preferences");
        }).catch((error) => {
            formatError(error.response.data.message)
        })

    }
}
export function saveJoiningStatusAction(data) {
    return () => {
        saveJoiningStatus(data).then((response) => {
            formatError(response.data.message);
        }).catch((error) => {
            formatError(error.response.data.message)
        })

    }
}
export function saveDistPrefAction(preferences, otp, navigate) {
    return (dispatch) => {
        saveDistPref(preferences, otp).then((response) => {
            formatSuccess(response.data.message);
            dispatch(savePrefSuccess(false))
            navigate("/post-preferences");
        }).catch((error) => {
            formatError(error.response.data.message)
        })

    }
}
export function savePostPrefAction(preferences, infodata, otp, navigate) {
    return (dispatch) => {
        savePostPref(preferences, infodata, otp).then((response) => {
            formatSuccess(response.data.message);
            dispatch(savePrefSuccess(false))
            navigate("/show-preferences");
        }).catch((error) => {
            formatError(error.response.data.message)
        })

    }
}
export function downloadOrderAction() {
    return (dispatch) => {
        downloadPostingOrder().then((response) => {
            dispatch({type:DOWN_ORDER_SUCCESS_ACTION, payload:response.data})
        }).catch((error) => {
            formatError(error.response.data.message)
        })

    }
}

export function sendOTP(message, role) {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        sentOtp().then((response) => {
            switch (role) {
                case "admin":
                    formatSuccess(response.data.message);
                    break;
                case "candidate":
                    formatPrefSuccess(dispatch, response.data.message, message);
                    break;
            }

            dispatch(sendOTPSuccess(true, role));
            dispatch(loadingToggleAction(false));
        }).catch((error) => {
            dispatch(sendOTPFailed(false, role));
            formatError(error.response.data.message)
            dispatch(loadingToggleAction(false));
        })

    }
}

function sendOTPSuccess(response, role) {
    if (role.toLowerCase() == "candidate") {
        return {
            type: SEND_OTP_ACTION,
            payload: response
        }
    }
    if (role.toLowerCase() == "admin") {
        return {
            type: SEND_OTP_ACTION_ADMIN,
            payload: response
        }
    }
}
function sendOTPFailed(response, role) {
    if (role.toLowerCase() == "candidate") {
        return {
            type: SEND_OTP_FAILED_ACTION,
            payload: response
        }
    }
    if (role.toLowerCase() == "admin") {
        return {
            type: SEND_OTP_FAILED_ACTION_ADMIN,
            payload: response
        }
    }
}

function fetchCategorySuccess(response) {
    return {
        type: FETCH_CATEGORY_SUCCESS_ACTION,
        payload: response
    }
}
function fetchDistrictSuccess(response) {
    return {
        type: FETCH_DISTRICT_SUCCESS_ACTION,
        payload: response
    }
}
function fetchPostsSuccess(response) {
    return {
        type: FETCH_POST_SUCCESS_ACTION,
        payload: response
    }
}
function fetchPrefsSuccess(response) {
    return {
        type: FETCH_PREFS_SUCCESS_ACTION,
        payload: response
    }
}
export function downloadPrefsSuccess(response) {
    return {
        type: DOWN_PREFS_SUCCESS_ACTION,
        payload: response
    }
}
export function downloadAdminPrefsSuccess(response) {
    return {
        type: DOWN_PREFS_ADMIN_SUCCESS_ACTION,
        payload: response
    }
}
function fetchCategoryFailed(response) {
    return {
        type: FETCH_CATEGORY_FAILED_ACTION,
        payload: response
    }
}
function fetchRegStatusSuccess(response) {
    return {
        type: FETCH_REG_STATUS_ACTION,
        payload: response
    }
}
function savePrefSuccess(response) {
    return {
        type: SAVE_PREF_STATUS_ACTION,
        payload: response
    }
}
export function formatPrefSuccess(dispatch, titleMsg, successMessage) {
    Swal.fire({
        icon: 'success',
        title: titleMsg,
        text: successMessage,
        allowOutsideClick: false,
        confirmButtonText: "I Agree",
        showCancelButton: true,
        cancelButtonText: "I Disagree",
        cancelButtonColor: "#f54343",
        customClass: {
            title: 'sw-al-pref-title'
        },
    }).then(function (dismiss) {
        if (dismiss.dismiss == 'cancel') {
            dispatch(resetPrefAction(true))
        }
    });
}

export function resetPrefAction(response) {
    return {
        type: 'PREF RESET',
        payload: response
    }
}